import React from 'react';
import { get } from 'lodash';
import moment from 'moment';
import { PauseTypography } from '../../../../components/PauseTypography';
import { SubscriptionStatus } from '../../../../types/billing';
import { PauseInteractiveButton } from '../../../../components/PauseInteractiveButton';

const getTrialExpiryDateFriendly = (date:string) => moment
  .duration(moment(date).diff(moment())).humanize();

type TrialExpiryCardProps = {
  onShowPlanDetails: () => any,
  trialExpiryDate: string,
  onStartSubscription: () => any,
  subscriptionStatus: SubscriptionStatus,
}
export const TrialExpiryCard = ({
  onShowPlanDetails = () => null,
  trialExpiryDate = '',
  onStartSubscription = () => null,
  subscriptionStatus,
}: TrialExpiryCardProps) => {
  const buttonText = React.useMemo(() => {
    if ([SubscriptionStatus.Trial, SubscriptionStatus.TrialExtended].includes(subscriptionStatus)) return 'Add card details';
    return 'Subscribe to Pause';
  }, [subscriptionStatus]);

  return (
    <div css={(theme) => ({
      display: 'grid',
      gridAutoFlow: 'columns',
      gridTemplateColumns: '3fr auto',
      alignItems: 'center',
      background: get(theme, 'palette.pause.background.medium'),
      padding: theme.spacing(3),
      borderRadius: theme.spacing(2),
      gridGap: theme.spacing(4),
    })}
    >
      <div>
        <PauseTypography
          css={(theme) => ({
            marginBottom: theme.spacing(1),
          })}
          variant="caption"
          color="error.main"
        >
          {[SubscriptionStatus.Trial, SubscriptionStatus.TrialExtended].includes(subscriptionStatus)
            ? `Your free trial will expire in ${getTrialExpiryDateFriendly(trialExpiryDate)}`
            : `Your free trial expired ${getTrialExpiryDateFriendly(trialExpiryDate)} ago`}
        </PauseTypography>
        <PauseTypography color="pause.primary.medium">
          {
            (subscriptionStatus === SubscriptionStatus.TrialExpired)
              ? 'Signup for Pause to continue using it.'
              : 'Add card details to continue using Pause after your trial ends.'
          }
          {' '}
          <a
            onClick={onShowPlanDetails}
            css={(theme) => ({
              color: get(theme, 'palette.pause.primary.dark'),
              cursor: 'pointer',
            })}
          >
            View plan details
          </a>
        </PauseTypography>
      </div>
      <div>
        <PauseInteractiveButton onClick={onStartSubscription}>
          {buttonText}
        </PauseInteractiveButton>
      </div>
    </div>
  );
};
